export { default } from './Categories.component';
